import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getItemId } from './SkuMenuData.normalizers';

const EDIT_ITEM_PARAM = 'editItem';

export default function useEditItemDeepLink({ skuItems, handleEditItemClick }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasFiredRef = useRef(false);

  const editItemId = searchParams.get(EDIT_ITEM_PARAM);

  useEffect(() => {
    if (!editItemId || hasFiredRef.current || !skuItems?.length) return;

    const matchedItem = skuItems.find(item => getItemId(item) === editItemId);
    if (!matchedItem) return;

    hasFiredRef.current = true;
    handleEditItemClick(matchedItem);

    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        next.delete(EDIT_ITEM_PARAM);
        return next;
      },
      { replace: true }
    );
  }, [editItemId, skuItems, handleEditItemClick, setSearchParams]);
}
